import React from 'react'
import { useNavigate } from "react-router-dom";

const Copyright = () => {
    const navigate = useNavigate();
  return (
    <div className="centerContent sm:text-center p-6 flex flex-col sm:flex-row">
        <p>Copyright © 2021&nbsp;</p>
        <p
          className="text-black font-semibold cursor-pointer hover:underline hover:text-tertiary"
          onClick={() => {
            // scroll to top if on home page else navigate to home page
            window.location.pathname === "/"
              ? window.scrollTo({ top: 0, behavior: "smooth" })
              : navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          Blend. All Rights Reserved.
        </p>
      </div>
  )
}

export default Copyright